import { render, staticRenderFns } from "./arrangeList.vue?vue&type=template&id=370b6ec6&scoped=true&"
import script from "./arrangeList.vue?vue&type=script&lang=js&"
export * from "./arrangeList.vue?vue&type=script&lang=js&"
import style0 from "./arrangeList.vue?vue&type=style&index=0&id=370b6ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b6ec6",
  null
  
)

export default component.exports